import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((next: number) => {
    setIndex(((next % total) + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 5500);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点影视海报`}
            title={`${slide.title} - 年轻的母亲在线推荐`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
        </div>
      ))}

      <div className="relative z-10 w-full h-full px-4 md:px-10 flex items-center">
        <div className="w-full max-w-[1440px] mx-auto">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 px-3 h-7 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold">
              <i className="ri-fire-line"></i>
              焦点推荐
            </span>
            <h1 className="mt-4 font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight">
              {heroSlides[index].title}
            </h1>
            <p className="mt-3 text-sm md:text-lg text-background-100/90">
              {heroSlides[index].subtitle}
            </p>
            <p className="mt-2 text-xs md:text-sm text-background-200/80">
              {heroSlides[index].meta}
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link
                to={`/detail/${heroSlides[index].id}`}
                className="px-6 h-11 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看剧情详情
              </Link>
              <Link
                to="/category/topic"
                className="px-6 h-11 inline-flex items-center justify-center gap-2 rounded-md bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/40 hover:bg-background-50/25 transition-colors backdrop-blur whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bookmark-3-line"></i>
                浏览主题专题
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => goTo(index - 1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/35 transition-colors backdrop-blur cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        onClick={() => goTo(index + 1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/35 transition-colors backdrop-blur cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => goTo(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-7 bg-accent-500" : "w-2.5 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}